module.exports = __webpack_public_path__ + "static/img/modal_742.bab99e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/modal/modal_742.png
// module id = jyxx
// module chunks = 7